import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'starts'
})
export class StartsPipe implements PipeTransform {

  transform(value: Array<any>, filter: string) {

    if (filter === 'all') {
      return value;
    }
    return value.filter(x =>  x['eventDescription'] === filter);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/starts/starts.ts